/* @jsx mdx */
import React from 'react';
import { mdx } from '@mdx-js/react'
/* @jsx mdx */

export const metadata = {
  title: 'Intro'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1>{`Welcome`}</h1>
    <p>{`This is the interactive guidebook for a workshop on WebGL and GLSL.`}</p>
    <p>{`We'll be using the following tools:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://threejs.org"
        }}>{`ThreeJS`}</a>{` to work with 3D, WebGL, and shaders`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/mattdesl/canvas-sketch/"
        }}>{`canvas-sketch`}</a>{` for exporting prints & animations`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://glitch.com/"
        }}>{`Glitch.com`}</a>{` for collecting and demoing some online and easily editable examples`}</li>
    </ul>
    <p>{`More links:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/mattdesl/workshop-webgl-glsl"
        }}>{`Workshop GitHub Repository`}</a></li>
    </ul>
    <p>{`Use the arrows in the nav bar or the Previous and Next buttons at the end of each slide to navigate this book.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
